import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import { TextIconButtonComponent } from "../../../../component/atom";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import {
    AdminQuestions,
    AdminQuestionView,
    PopUpMessageComponent,
    DocumentAssociationDialog,
    QandACard,
} from "../../../../component/molecule";
import { useNavigate, useLocation } from "react-router-dom";
import { faEye, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import _ from "lodash";
import moment from "moment";
import { AdminQuestionsEdit } from "../../../../component/molecule/Forms";
import { useQuestionEdit } from "../../../../hook/useQuestionEdit";
import { ASSOCIATION_ACTION } from "../../../../core/Constant";

const AdminQuizEditSecondScreen = ({
    getQuizeList,
    quizList,
    deleteQuize,
    getAllStateCourseList,
    getCourseList,
    getQuizQuestionAndAnswerByQuizId,
    questionAndAnswersList,
    getCategoryList,
    getSubjectList,
    removeQuestionfromQuiz,
    rearrangeQuizQuestions,
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [addQuestion, setAddQuestion] = useState(false);
    const [deleteQuiz, setDeleteQuiz] = useState(false);
    const [selectQuiz, setSelectedQuiz] = useState("");
    const [courseId, setCourseId] = useState(0);
    const [list, setList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [questionsList, setQuestionsList] = useState([]);
    const [viewQuestion, setViewQuestion] = useState(false);
    const [categoryIds, setCategoryIds] = useState([]);
    const [quizData, setQuizData] = useState({});
    const [draggedQuestionIndex, setDraggedQuestionIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [quizid, setQuizId] = useState(0);
    const [onDeletePopup, setOnDeletePopUp] = useState(false);
    const [allQuiz, setAllQuiz] = useState([]);

    const {
        selectedItem,
        setSelectedItem,
        showEditWarning,
        editQuestion,
        editingQuestionId,
        associateQuizzes,
        handleEditQuestion,
        onConfirmEdit,
        onCancelEdit,
        onEditQuestionClose,
    } = useQuestionEdit();

    useEffect(() => {
        let quizdata = location?.state?.quizData;
        if (!quizdata) {
            try {
                quizdata = JSON.parse(localStorage.getItem('newQuiz'))
            } catch (err) {
                quizdata = {};
            }
        }

        const activeId = location?.state?.id || quizdata?.id;

        if (activeId) {
            setQuizData(quizdata || {});
            setQuizId(activeId);
            getQuizQuestionAndAnswerByQuizId(activeId);
        }

        getCategoryList();
        getSubjectList();
        getQuizeList();
        getAllStateCourseList();
        getCourseList();
    }, []);

    useEffect(() => {
        setQuestionsList(questionAndAnswersList)
    }, [questionAndAnswersList])

    useEffect(() => {
        if (Array.isArray(questionsList) && questionsList.length > 0) {
            const ids = questionsList
                .filter(Boolean)
                .map((question) => question?.category_id)
                .filter(Boolean);
            setCategoryIds(ids);
        }
    }, [questionsList]);

    useEffect(() => {
        if (courseId === 0 && Array.isArray(quizList)) {
            const formattedList = quizList
                .filter(Boolean)
                .map((item) => {
                    const createdDate = moment(_.get(item, "created_at", new Date())
                    ).format("DD/MM/YYYY HH:mm:ss"
                    );
                    return { ...item, createdDate };
                });
            setAllQuiz(formattedList);
        }
    }, [quizList, courseId]);

    useEffect(() => {
        if (Array.isArray(quizList)) {
            const foundObject = quizList.filter((item) => item?.id === courseId);
            setList(foundObject);
            setOriginalList(foundObject)
        }
    }, [quizList, courseId]);

    const onDeleteQuize = () => {
        deleteQuize(selectQuiz);
        onDeleteClose();
    };

    const onDeleteClose = () => {
        setDeleteQuiz(false);
        setSelectedQuiz("");
    };

    const onViewOff = () => {
        setViewQuestion(false);
        setSelectedItem({});
    };

    const handleEditQuestionClose = () => {
        onEditQuestionClose(() => {
            if (quizid) {
                getQuizQuestionAndAnswerByQuizId(quizid);
            }
        });
    };

    const onDelete = () => {
        setOnDeletePopUp(false);
        removeQuestionfromQuiz({
            quiz_id: quizid,
            question_id: selectedItem?.id ?? selectedItem?.question_id,
        })
        _.delay(() => {
            setSelectedItem({});
        }, 1000);
    };

    const onNotDelete = () => {
        setOnDeletePopUp(false);
        setSelectedItem({});
    };

    const persistReorderedQuestions = () => {
        const questionIds =
            questionsList
                ?.filter(Boolean)
                ?.map((question) => question?.id ?? question?.question_id)
                ?.filter(Boolean) || [];
        if (quizid && questionIds.length > 0) {
            rearrangeQuizQuestions({
                quiz_id: quizid,
                question_ids: questionIds,
            });
        }
    };

    const handleQuestionDragStart = (event, index) => {
        event.stopPropagation();
        event.dataTransfer.effectAllowed = "move";
        try {
            event.dataTransfer.setData("text/plain", String(index));
        } catch (error) {
            // Some browsers (Safari) might throw if setData is not allowed; ignore silently.
        }
        setDraggedQuestionIndex(index);
        setDragOverIndex(index);
    };

    const handleQuestionDragOver = (event, index) => {
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "move";
        if (draggedQuestionIndex === null || draggedQuestionIndex === index) {
            return;
        }
        if (dragOverIndex !== index) {
            setDragOverIndex(index);
        }
    };

    const handleQuestionDrop = (event, index) => {
        event.preventDefault();
        event.stopPropagation();
        if (draggedQuestionIndex === null || draggedQuestionIndex === index) {
            handleQuestionDragEnd();
            return;
        }
        setQuestionsList((prevQuestions) => {
            if (!Array.isArray(prevQuestions)) {
                return prevQuestions;
            }
            const updatedQuestions = [...prevQuestions];
            const [movedQuestion] = updatedQuestions.splice(draggedQuestionIndex, 1);
            updatedQuestions.splice(index, 0, movedQuestion);
            return updatedQuestions;
        });
        handleQuestionDragEnd();
    };

    const handleQuestionDragLeave = (event, index) => {
        event.stopPropagation();
        if (dragOverIndex === index) {
            setDragOverIndex(null);
        }
    };

    const handleQuestionDragEnd = (event) => {
        if (event) event.stopPropagation();
        setDraggedQuestionIndex(null);
        setDragOverIndex(null);
    };

    return (
        <>
            <Box className="main-screen-container">
                <Grid container direction="row" justifyContent="space-between">
                    <Grid item>
                        <HeadingComponent
                            text={"Edit Quiz"}
                            fontweigth={600}
                            size={40}
                            backNavigation={true}
                            fontfamily={"Montserrat"}
                        />
                    </Grid>

                    <Grid item className="student-search-btn-section" columnGap={2}>
                        <TextIconButtonComponent
                            btnText={"Add Question"}
                            icon={faQuestionCircle}
                            animation={"shake"}
                            onclick={() => setAddQuestion(true)}
                        />
                        <TextIconButtonComponent
                            btnText={"Select Question"}
                            icon={faEye}
                            onclick={() => navigate("/admin-question-select", {
                                state: { quizId: quizid },
                            })
                            }
                        />
                    </Grid>
                </Grid>
                <Box className="common-admin-content-wrap">
                    <Grid container>
                        <Grid item>
                            <HeadingComponent
                                fontfamily={"Montserrat"}
                                size={24}
                                color={"#4e657c"}
                                text={
                                    "Selected Questions"
                                }
                            />

                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid xs={12} item>
                            {Array.isArray(questionsList) &&
                                questionsList.map((item, index) => (
                                    <QandACard
                                        key={item?.id ?? index}
                                        isView={true}
                                        isEdit={true}
                                        isDelete={true}
                                        draggable
                                        onDragStart={(event) => handleQuestionDragStart(event, index)}
                                        onDragOver={(event) => handleQuestionDragOver(event, index)}
                                        onDrop={(event) => handleQuestionDrop(event, index)}
                                        onDragEnd={handleQuestionDragEnd}
                                        onDragLeave={(event) => handleQuestionDragLeave(event, index)}
                                        isDragging={draggedQuestionIndex === index}
                                        isDragOver={dragOverIndex === index && draggedQuestionIndex !== index}
                                        onclick={() => {
                                            setViewQuestion(true);
                                            setSelectedItem(item);
                                        }}
                                        onPressEdit={() => handleEditQuestion(item, quizData?.quiz_name || quizData?.name)}
                                        isEditing={editingQuestionId === (item?.id ?? item?.question_id)}
                                        onPressDelete={() => {
                                            setOnDeletePopUp(true);
                                            setSelectedItem(item);
                                        }}
                                        index={index}
                                        item={item}
                                    />
                                ))
                            }
                        </Grid>
                    </Grid>

                    <Grid mt={10} alignItems={'flex-end'} justifyContent={'flex-end'} container>
                        <Grid item >

                            <TextIconButtonComponent
                                btnText={"Next"}
                                animation={"shake"}
                                onclick={() => {
                                    persistReorderedQuestions();
                                    navigate('/admin-quiz-grade', { state: { categoryIds: categoryIds, quizId: quizid } })
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <PopUpMessageComponent
                open={deleteQuiz}
                type={"other"}
                title={"Delete!"}
                message={"Are you sure you want delete quiz?"}
                btntext={"Yes, delete"}
                altbtntext={"No"}
                onclick={onDeleteQuize}
                altonclick={onDeleteClose}
                onclose={onDeleteClose}
            />

            <AdminQuestions
                open={addQuestion}
                quizData={quizData}
                onClose={() => {
                    setAddQuestion(false);
                    // Refresh question list after closing
                    if (quizid) {
                        getQuizQuestionAndAnswerByQuizId(quizid);
                    }
                }}
            />
            <DialogComponent
                isShowCloseButton={true}
                title={"View Question"}
                maxwidth={"lg"}
                open={viewQuestion}
                onClose={onViewOff}
            >
                <AdminQuestionView item={selectedItem} onClose={() => onViewOff()} />
            </DialogComponent>

            <DialogComponent
                isShowCloseButton={true}
                title={"Edit Question"}
                maxwidth={"lg"}
                open={editQuestion}
                onClose={handleEditQuestionClose}
            >
                <AdminQuestionsEdit
                    questionDetails={selectedItem}
                    onClose={handleEditQuestionClose}
                />
            </DialogComponent>

            {showEditWarning && (
                <DocumentAssociationDialog
                    association={{
                        data: associateQuizzes,
                        action: ASSOCIATION_ACTION.EDIT,
                        entityType: "question",
                        entityName: (selectedItem?.question || selectedItem?.name || "").replace(/<[^>]*>/g, ""),
                    }}
                    onConfirm={onConfirmEdit}
                    onClose={onCancelEdit}
                />
            )}

            <PopUpMessageComponent
                open={onDeletePopup}
                type={"other"}
                title={"Delete Question !"}
                message={"Are you sure you want to delete this question??"}
                btntext={"Yes, delete"}
                altbtntext={"No"}
                altonclick={onNotDelete}
                onclick={onDelete}
                onclose={onNotDelete}
            />
        </>
    );
};

export default connect(
    (state) => ({
        quizList: state.quizes.get("quizList"),
        courseList: state.students.get("commonCourseList"),
        questionAndAnswersList: state.quizes.get("questionAndAnswersList"),
    }),
    {
        getQuizeList: Actions.quizes.getQuizeList,
        upDateQuizState: Actions.quizes.upDateQuizState,
        getQuizById: Actions.quizes.getQuizById,
        deleteQuize: Actions.quizes.deleteQuize,
        verifyToken: Actions.auth.verifyToken,
        getAllStateCourseList: Actions.course.getAllStateCourseList,
        getCourseList: Actions.quizes.getCourseListByQuiz,
        getQuizQuestionAndAnswerByQuizId:
            Actions.quizes.getQuizQuestionAndAnswerByQuizId,
        getCategoryList: Actions.questions.getCategoryList,
        getSubjectList: Actions.questions.getSubjectList,
        removeQuestionfromQuiz: Actions.quizes.removeQuestionfromQuiz,
        rearrangeQuizQuestions: Actions.quizes.rearrangeQuizQuestions,
    }
)(AdminQuizEditSecondScreen);
